module.exports = __webpack_public_path__ + "static/media/Character4.5cfd7967.png";